import { Box, Image, Text } from "@chakra-ui/react";
import React from "react";
import ComingSoon1 from "../../src/assets/ComingSoon/ComingSoon1.gif";
import build from "../../src/assets/ComingSoon/build.png";

const ComingSoon = () => {
  return (
    <Box h={"565"}>
      <Box h={"100"}>
        <Text
          color={"#3C375F"}
          fontFamily="Oswald, sans-serif"
          fontSize={{ base: "20", md: "28", lg: "28" }}
          fontWeight={"Bold"}
          h={"100"}
          mt={"10"}
          ml={"10"}
        >
          Hang on... We're Working On. <br />
          Something Big Is Coming!
        </Text>
        <Box>
          <Image
            margin={"auto"}
            src={ComingSoon1}
            alt="Coming Soon"
            boxSize={"200px"}
          />
          <Image margin={"auto"} src={build} alt="Coming Soon" h={"100%"} />
        </Box>
      </Box>
    </Box>
  );
};

export default ComingSoon;
